<template>
<div>
  <v-flex pt-4 class="carousel-hight">
    <div
      class="decorated text-27-security white--text font-weight-bold"
      style="padding-top: 10px; letter-spacing: 1.5px;"
    >
      <span>MOMENTOS SECURITY</span>
    </div>
    <!-- Carousel Momentos Security -->
    <v-layout row wrap justify-center mt-4>
      <v-flex xs10 sm10 text-md-center>
        <vueper-slides
          autoplay
          ref="vueperslides1"
          :touchable="false"
          @slide="$refs.vueperslides2 && $refs.vueperslides2.goToSlide($event.currentSlide.index, { emit: false })"
          class="no-shadow"
          style="height: 280px;"
          :visible-slides="window.width<= 450 ? 1 : 3"
          slide-multiple
          :gap="3"
          :slide-ratio="window.width<= 450 ? 1 : 1 / 4"
          :dragging-distance="200"
          :breakpoints="window.width<= 450 ? { 800: { visibleSlides: 1, slideMultiple: 2 } } : { 800: { visibleSlides: 2, slideMultiple: 2 } }"
          :bullets="window.width<= 450 ? false : true"
        >
          <template v-slot:arrow-left>
            <img class="carousel-arrow-left" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/chevron-left-solid.svg" alt="">
          </template>
          <template v-slot:arrow-right>
            <img class="carousel-arrow" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/angle-right-solid.svg" alt="">
          </template>
          <vueper-slide
            :duration="9000"
            v-for="gallery in galleries.slice(0,9)"
            :key="gallery.id"
            :image="gallery.main_image"
            @click.native="goToGallery(gallery.post_slug)"
            style="border: 2px solid white; cursor: pointer;"
          />
        </vueper-slides>

        <vueper-slides
          :touchable="false"
          ref="vueperslides2"
          :slide-ratio="1 / 4"
          :dragging-distance="50"
          @slide="$refs.vueperslides1 && $refs.vueperslides1.goToSlide($event.currentSlide.index, { emit: false })"
          :visible-slides="window.width<= 450 ? 1 : 3"
          class="no-shadow"
          fixed-height="100px"
          :arrows="false"
          :breakpoints="window.width<= 450 ? { 800: { visibleSlides: 1, slideMultiple: 2 } } : { 800: { visibleSlides: 2, slideMultiple: 2 } }"
          slide-multiple
          :gap="3"
          :bullets="false"
        >
          <vueper-slide
            v-for="(gallery, i) in galleries.slice(0,9)"
            :key="i"
          >
            <template v-slot:content>
              <div
                class="vueperslide__content-wrapper"
                :style="'background-color: ' + ['transparent', 'transparent'][i % 2]"
              >
                <div class="vueperslide__title text-14-security font-weight-bold white--text text-uppercase">{{ gallery.name.substr(0, 45) }}</div>
              </div>
            </template>
          </vueper-slide>
        </vueper-slides>
      </v-flex>
    </v-layout>
    <!-- /Carousel Momentos Security -->
    <v-flex xs12 text-xs-right class="btn-ver-mas">
      <v-btn
        color="#211651"
        class="white--text btn-security"
        style="z-index: 1;"
        to="momentos-security"
      >Ver más</v-btn>
    </v-flex>
  </v-flex>

</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  components: {
    VueperSlides,
    VueperSlide
  },
  data() {
    return {
      windowWidth: screen.width,
      window: {
        width: 0,
        height: 0
      }
    };
  },
  beforeMount() {
    if (!this.galleries.length) {
      let view_as = localStorage.getItem("view_as");
      this.fetchGalleries(view_as);
    }
  },
  methods: {
    ...mapActions("galleries", ["fetchGalleries"]),
    goToGallery(postSlug) {
      if (postSlug.length) {
        this.$router.push({
          name: "post-show",
          params: { slug: postSlug }
        });
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  },
  computed: {
    ...mapState("galleries", ["galleries"])
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style>
@media screen and (min-width: 300px) and (max-width: 325px) {
  /* Posición botón "Ver más" */
  .btn-ver-mas {
    margin-top: -39px;
    margin-left: -25%;
  }
  /* Altura de carousel */
  .carousel-hight {
    background-image: linear-gradient(to right, #211651, #789c4a);
    height: 35rem;
  }
  /* Posición nombre de galería */
  .vueperslides--fixed-height .vueperslide {
    height: 7em;
  }
}

@media screen and (min-width: 326px) and (max-width: 360px) {
  .btn-ver-mas {
    margin-top: -1em;
    margin-left: -7.5em;
  }

  .carousel-hight {
    background-image: linear-gradient(to right, #211651, #789c4a);
    height: 37rem;
  }

  .vueperslides--fixed-height .vueperslide {
    height: 13em;
  }
}

@media screen and (min-width: 361px) and (max-width: 374px) {
  .btn-ver-mas {
    margin-top: -39px;
    margin-left: -8rem;
  }

  .carousel-hight {
    background-image: linear-gradient(to right, #211651, #789c4a);
    height: 40rem;
  }
}

@media screen and (min-width: 375px) and (max-width: 390px) {
  .btn-ver-mas {
    margin-top: 0em;
    margin-left: -8rem;
  }

  .carousel-hight {
    background-image: linear-gradient(to right, #211651, #789c4a);
    height: 38rem;
  }

  .vueperslides--fixed-height .vueperslide {
    height: 15em;
  }
}

@media screen and (min-width: 391px) and (max-width: 415px) {
  .btn-ver-mas {
    margin-top: 2em;
    margin-left: -9rem;
  }

  .carousel-hight {
    background-image: linear-gradient(to right, #211651, #789c4a);
    height: 41rem;
  }

  .vueperslides--fixed-height .vueperslide {
    height: 22em;
    padding-bottom: 0;
  }
}

@media screen and (min-width: 416px) and (max-width: 425px) {
  .btn-ver-mas {
    margin-top: 2em;
    margin-left: -9.5rem;
  }

  .carousel-hight {
    background-image: linear-gradient(to right, #211651, #789c4a);
    height: 40rem;
  }

  .vueperslides--fixed-height .vueperslide {
    height: 22em;
  }
}

@media screen and (min-width: 426px) and (max-width: 768px) {
  .btn-ver-mas {
    margin-top: -39px;
    margin-left: 39%;
  }

  .carousel-hight {
    background-image: linear-gradient(to right, #211651, #789c4a);
    height: 31rem;
  }
}

@media screen and (min-width: 769px) {
  .carousel-hight {
    background-image: linear-gradient(to right, #211651, #789c4a);
    height: 523px;
  }

  .btn-ver-mas {
    margin-top: -90px;
    padding-right: 32px;
  }

  .vueperslides__arrows--outside .vueperslides__arrow--prev {
    left: -6.5em;
  }

  .vueperslides__arrows--outside .vueperslides__arrow--next {
    right: -6.5em;
  }
}

.vueperslides__bullets {
  bottom: -81px;
}

.vueperslides__bullet .default {
  background-color: rgba(255, 255, 255, 0.5);
  border: none;
  box-shadow: none;
  transition: 0.3s;
  width: 18px;
  height: 18px;
  margin: 0 5px;
}

.vueperslides__bullet--active .default {
  background-color: rgba(120, 156, 74, 0.5);
}

.vueperslide__content-wrapper:not(.vueperslide__content-wrapper--outside-top):not(.vueperslide__content-wrapper--outside-bottom) {
  height: 60%;
  margin: 0;
}

.decorated {
  overflow: hidden;
  text-align: center;
}
.decorated > span {
  position: relative;
  display: inline-block;
}
.decorated > span:before,
.decorated > span:after {
  content: "";
  position: absolute;
  top: 50%;
  border-bottom: 1px solid;
  width: 155%; /* half of limiter*/
  margin: 0 38px;
}
.decorated > span:before {
  right: 100%;
}
.decorated > span:after {
  left: 100%;
}
.carousel-arrow-left{
  width: 43px;
  filter: invert(100%) sepia(4%) saturate(7470%) hue-rotate(214deg) brightness(113%) contrast(101%);
}
.carousel-arrow{
  width: 40px;
  filter: invert(100%) sepia(4%) saturate(7470%) hue-rotate(214deg) brightness(113%) contrast(101%);
}
</style>